'use strict';

// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {
		//resizeWindow();
		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			//scrollDown();
		});
		// Main Nav Dropdown
		// $("#primary-nav li").hover(function(){
		// 	$(this).addClass("hover");
		// 	$('ul.submenu',this).fadeIn(200);
		// }, function(){
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu',this).fadeOut(200);
		// });

		//    $('ul#privary-navigation li.privary-navigation__item a').click(function(){
		//     $('li.privary-navigation__item a').removeClass("active");
		//     $(this).addClass("active");
		// });

		/* primary nav updated */
		$('.menu').html(function (buscayreemplaza, reemplaza) {
			return reemplaza.replace('<nav id="primary-nav" class="privary-navigation" role="navigation" aria-label="Primary">', '<nav id="primary-nav" class="privary-navigation" role="navigation">');
		});

		/*function to change Redundant WAI-ARIA labels to third-nav on the footer */
		$('.block-footer__tertiary-menu').html(function (buscayreemplaza, reemplaza) {
			return reemplaza.replace('<nav id="third-nav" class="tertiary-navigation" role="navigation" aria-labelledby="third-nav" aria-label="Fine Print">', '<nav id="third-nav" class="tertiary-navigation" role="navigation">');
		});

		/* change to update sign up*/
		$('.fields-wrap').html(function (buscayreemplaza, reemplaza) {
			return reemplaza.replace('<div role="group" class="gdpr-wrap" aria-labelledby="gdpr-checkboxes-signupemail-signup">', '<div role="group" class="gdpr-wrap">');
		});

		var current_url = document.URL;
		if (current_url[current_url.length - 1] != "/") {
			$('body.sitemap li.privary-navigation__item a, body.privacy-policy li.privary-navigation__item a, body.accessibility li.privary-navigation__item a').each(function () {
				var aux = $(this).attr('href');
				$(this).attr('href', "/" + aux);
			});
		}

		// $.each( $('body.sitemap li.privary-navigation__item.primary-nav-1 a'), function(index, value) {
		// 	$(value).attr('href', '/#menus');
		// });

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	});

	/* Parralax to intro content */
	var $parallaxElement = $('.intro-content-home__image');
	var elementHeight = $parallaxElement.outerHeight();

	function parallax() {
		var scrollPos = $(window).scrollTop();
		var transformValue = scrollPos / 20;
		var opacityValue = 1 - scrollPos / 1000;
		var blurValue = Math.min(scrollPos / 50, 3);

		if (scrollPos < elementHeight) {

			$parallaxElement.css({
				'transform': 'translate3d(0, -' + transformValue + '%, 0)',
				'opacity': opacityValue,
				'-webkit-filter': 'blur(' + blurValue + 'px)'
			});
		}
	}

	window.onload = function () {
		/*this function add a class to header when scroll down the page
  /* and change the logo by a new file if needed depending of mockup
  */

		// scrollDownAction(20, 'scroll');

		scrollW();
		parallax();
		window.addEventListener('scroll', function () {
			scrollW();
		});

		/* Animation to anchor scroll */
		$('.privary-navigation__item a[href*=\\#], a[href*=\\#].scroll-indicator').on('click', function (e) {

			var current_url = document.URL;
			if (current_url[current_url.length - 1] == "/") {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $(this.hash).offset().top + 60
				}, 2000);
				return false;
			}
		});
	};
})();

/* detect Viewpoint to each section */
var isInViewport = function isInViewport(elem) {
	var bounding = elem.getBoundingClientRect();
	return bounding.top >= -400 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var children = '';
var on_top = true;

var footerEl = document.getElementById('footer');

function scrollW() {
	if (isInViewport(document.getElementById('end-footer'))) {
		console.log('Im here');
		$('.header__logo, .menu').hide(300);
		$('#header').addClass('show-scroll');
	} else {
		$('.header__logo, .menu').show();
		$('#header').removeClass('show-scroll');
	}

	//check scroll down or up for header styles
	var st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		on_top = false;
		if (st > lastScrollTop) {

			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {

		on_top = true;

		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}

	if (!on_top) {

		children = document.querySelectorAll('.full-intro-content__container section');

		children.forEach(function (index, value) {

			if (isInViewport(index)) {

				var element = document.querySelectorAll("#privary-navigation [href='#" + index.id + "']");
				if (element.length > 0) {
					element = element.item(0);
					//element.classList.remove('active');
					element.classList.add('active');
				}
			} else {

				var element = document.querySelectorAll("#privary-navigation [href='#" + index.id + "']");
				if (element.length > 0) {
					element = element.item(0);
					//element.classList.add('active');
					element.classList.remove('active');
				}
			}
		});
	} else {

		children = document.querySelectorAll("#privary-navigation a");
		children.forEach(function (index, value) {
			if (typeof index != null) index.classList.remove('active');
		});
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/* function to slider by title to each active element*/
$("#slider").slick({
	dots: true,
	customPaging: function customPaging(slider, i) {
		return '<button>' + '<span class="content-all-blog__title-bull">' + $(slider.$slides[i]).attr('title') + '</span></button>';
	},
	arrows: false,
	slidesToShow: 1,
	slidesToScroll: 1
});

/* funtion to button "Reserve Table" to open a new windown by a fuction*/
// function reserveTable() {
// 	window.open('https://www.opentable.com/restref/client/?rid=1062928&restref=1062928&partysize=2&datetime=2020-02-28T19%3A00&lang=en-US&r3uid%5B0%5D=LkeaeRAm&r3uid%5B1%5D=LkeaeRAm&ot_source=Restaurant%20website&corrid=7b74d328-b71c-4c63-b47c-9549d8719f08');
// }